
define('text!templates/content/home.html',[],function () { return '<div class="panel panel-transparent">\n    <div class="panel-body">\n        Welcome To SambaPOS Community Portal\n    </div>\n</div>';});

